import React from "react";
import {
    Text,
    View,
    StyleSheet,
    TouchableOpacity,
    Linking,
} from "react-native";
import { get, map } from "lodash";
import { Flex, Colors } from "../../styles/appStyles";
import CustomImage from "../custom-image";
import getImagePath from "../../utils/image-helper";

const greenTick = getImagePath("icons/green-tick.png");

const PlanCard = ({ plan, isSubscribedToTmcPrivate, userProfile }) => {
    const { id, description } = plan;
    const displayName = get(description, "display_name", "");
    const accessDesc = get(description, "access_desc", []);
    const countryCode = get(plan, "currency_code", "");
    const isAED = isSubscribedToTmcPrivate
        ? get(userProfile, "private_subscription.plan.currency_code", "") === "AED"
        : countryCode === "AED";
    const price = isSubscribedToTmcPrivate
        ? get(userProfile, "private_subscription.plan.price", 0)
        : get(plan, "price", 0);

    const handleSelectPlan = () => {
        const url = `/tmc-private/checkout?planId=${id}&booking=1`;
        Linking.openURL(url);
    };

    return (
        <View style={styles.container}>
            <View style={styles.cardWrapper}>
                <Text style={styles.displayName}>{displayName}</Text>

                <Text style={styles.priceText}>
                    <Text style={styles.currencySymbol}>{isAED ? "AED " : "₹"}</Text>
                    {price}
                </Text>
                {!isSubscribedToTmcPrivate && (
                    <TouchableOpacity
                        style={styles.selectButton}
                        onPress={handleSelectPlan}
                        testID={`checkout-button-${id}`}
                    >
                        <Text style={styles.selectButtonText}>SELECT PLAN</Text>
                    </TouchableOpacity>
                )}

                <View>
                    <Text style={styles.includedTitle}>What's Included</Text>
                    {map(accessDesc, (desc, index) => {
                        return (
                            <View
                                key={index}
                                style={[Flex.row, Flex.alignCenter, styles.accessItem]}
                            >
                                <CustomImage
                                    source={greenTick}
                                    style={{ width: 10, height: 10, objectFit: "contain" }}
                                    webStyle={{ width: 15, height: 15, objectFit: "contain" }}
                                    className={"green-tick-icon"}
                                    altText={name}
                                />
                                <Text style={styles.accessDescText}>{desc}</Text>
                            </View>
                        );
                    })}
                </View>
                {isSubscribedToTmcPrivate && (
                    <TouchableOpacity style={styles.selectButton}>
                        <Text style={styles.selectButtonText}>CURRENT PLAN</Text>
                    </TouchableOpacity>
                )}
            </View>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        marginVertical: 24,
        flexDirection: "column",
        marginHorizontal: "auto",
        maxWidth: 400,
        height: "100%",
    },
    cardWrapper: {
        backgroundColor: "#FFF8E1",
        padding: 28,
        borderWidth: 1,
        borderColor: "#FFD54F",
        marginTop: 32,
    },
    displayName: {
        color: Colors.blue,
        fontWeight: "600",
        fontSize: 32,
        lineHeight: 40,
        textTransform: "uppercase",
        letterSpacing: 1,
    },
    priceText: {
        fontWeight: "800",
        fontSize: 34,
        color: Colors.blue,
        marginTop: 4,
        marginBottom: 16,
    },
    selectButton: {
        width: "100%",
        paddingVertical: 8,
        backgroundColor: Colors.blue,
        marginTop: 16,
        marginBottom: 24,
        alignItems: "center",
        justifyContent: "center",
    },
    selectButtonText: {
        fontWeight: "500",
        textTransform: "uppercase",
        fontSize: 17,
        letterSpacing: 0.5,
        color: Colors.whiteColor,
        textAlign: "center",
    },
    includedTitle: {
        color: Colors.blue,
        fontSize: 16,
        fontWeight: "400",
        marginBottom: 16,
    },
    accessItem: {
        gap: 12,
        marginBottom: 8,
    },
    rightMarkIcon: {
        width: 20,
        height: 20,
    },
    accessDescText: {
        color: Colors.blue,
        fontWeight: "400",
        fontSize: 17,
        lineHeight: 28,
        letterSpacing: 0.5,
    },
});

export default PlanCard;
